var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from '@mui/material';
import { theme } from './ButtonComponentTheme';
var ButtonComponent = function (_a) {
    var title = _a.title, _b = _a.variant, variant = _b === void 0 ? 'contained' : _b, stylesType = _a.stylesType, handleClick = _a.handleClick, isDisabled = _a.isDisabled, _c = _a.type, type = _c === void 0 ? 'button' : _c, _d = _a.customStyles, customStyles = _d === void 0 ? {} : _d;
    return (_jsx(Button, { variant: variant, sx: stylesType === 'cancel' ? __assign(__assign({}, customStyles), theme.cancelButton) : __assign(__assign({}, customStyles), theme.submit), onClick: handleClick, disabled: isDisabled, type: type, children: title }));
};
export default ButtonComponent;
